<template>
  <credit-widget data-testid="business-income-widget">
    <template #widget-header>
      <div
        class="d-flex flex-grow-1 justify-content-between align-items-center"
      >
        <div class="d-flex i-gap-sm align-items-center">
          <i-icon
            class="icon i-text-neutral-110"
            symbol="small-money-wallet-1"
            :size="16"
          ></i-icon>
          <span>{{ widgetHeadingText }}</span>
        </div>
        <div
          role="button"
          data-testid="view-business-income-insights-button"
          @click="viewIncomeInsights"
        >
          <i-badge
            class="i-ml-4"
            :colour="iBadgeColours.PRIMARY"
            label="View"
            interactable
            alt-text-colour
            has-trailing-icon
            icon="small-arrows-right-small"
            @right-icon-click="viewIncomeInsights"
          />
        </div>
      </div>
    </template>
    <template #widget-content>
      <div class="line">
        <span>Estimated Annual Gross</span>
        <credit-widget-value
          :value="annualGross"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div class="line">
        <span>Period Gross</span>
        <credit-widget-value
          :value="periodGross"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div class="line">
        <span>Count of Deposits</span>
        <credit-widget-value :value="depositsCount"></credit-widget-value>
      </div>
      <div class="line">
        <span>Average Deposit Amount</span>
        <credit-widget-value
          :value="avgDepositAmount"
          :currency="true"
        ></credit-widget-value>
      </div>
    </template>
  </credit-widget>
</template>

<script>
import { iIcon, iBadge, iBadgeColours } from '@inscribe/signal';
import CreditWidget from '@/V2/credit/widgets/CreditWidget';
import CreditWidgetValue from '@/V2/credit/widgets/CreditWidgetValue';
import { BUSINESS_INCOME_INSIGHTS_SLUG } from '@/V2/credit/granular-insights/constants';
import { getAndSyncQueryParams } from '@/utils/queryParams';
import { getUseAllDocsQueryParameter } from '@/V2/credit/utils';

export default {
  name: 'IncomeBusiness',
  components: { CreditWidget, CreditWidgetValue, iIcon, iBadge },
  props: {
    widgetData: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      iBadgeColours,
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  computed: {
    annualGross() {
      return this.widgetData?.transaction_data?.estimated_annual_gross;
    },
    periodGross() {
      return this.widgetData?.transaction_data?.period_gross;
    },
    depositsCount() {
      return this.widgetData?.transaction_data?.count_deposits;
    },
    avgDepositAmount() {
      return this.widgetData?.transaction_data?.average_deposit_amount;
    },
    widgetHeadingText() {
      return 'Business Income Insights';
    },
    useAllDocsQueryParameter() {
      return getUseAllDocsQueryParameter(this.params);
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    viewIncomeInsights() {
      this.$router.push({
        name: 'customer-credit-granular-insight',
        params: { type: BUSINESS_INCOME_INSIGHTS_SLUG },
        query: {
          use_all_docs: this.useAllDocsQueryParameter,
        },
      });
    },
  },
};
</script>
